
import {
  getRecomment,
  getSimpleLastest,
  getSimpleHistory,
  getTopic, // 获取模板相关专题列表
  getRelatedArticle, // 获取模板相关文章
  getRelatedSeoProject, // 获取模板相关历史项目
} from '~/api/library-center/common.js'
export default {
  name: 'LibFooterCard',
  props: {
    // 隐藏几个模块，包含索引值的将被隐藏
    hideList: {
      type: Array,
      default: Array,
    },
    dataList: {
      type: Array,
      default: Array,
    },
    // 选中一个触发事件
    selected: {
      type: Function,
      default: null,
    },
    showType: {
      type: Boolean,
      default: true,
    },
    // 固定高度
    height: {
      type: String,
      default: '280px',
    },
  },
  data() {
    return {
      data: null,
      loading: true,
    }
  },
  async fetch() {
    const id = this.$route?.params?.id
    await (this.showType ? this.getData() : this.getItem(id))
  },
  computed: {
    footerCardList() {
      return this.data || this.dataList
    },
  },
  methods: {
    click(item, feild, i, index) {
      if (this.selected) return this.selected(item, feild, i, index)
      const { name } = item
      const selectType = new Map([
        ['相关专题', (feild) => `/topic_detail/${feild.id}`],
        ['相关文章', (feild) => feild.url.replace('http://', 'https://')],
        ['历史问卷', (feild) => `/${feild.link_prefix}/${feild.short_id}/`],
        ['最新模板', (feild) => `/lib_detail_full/${feild.oid}`],
        ['历史项目', (feild) => `/static_history/?func_id=${feild.oid}`],
        ['default', (feild) => `/topic_detail/${feild.oid}`],
      ])
      const url = (selectType.get(name) || selectType.get('default'))(feild)
      return url
    },
    getItem(id) {
      const taskList = [getSimpleLastest, getTopic, getRelatedArticle, getRelatedSeoProject]
      return Promise.all(taskList.map((v) => v(id)))
        .then(
          ([
            {
              data: { list_data: lastest },
            },
            { data: topic },
            { data: article },
            { data: history },
          ]) => {
            this.data = [
              {
                name: '最新模板',
                children: lastest.map((v) => ({
                  ...v,
                  count: `共${v.question_count}题/${v.page_count}页`,
                })),
              },
              {
                name: '相关专题',
                children: topic,
              },
              {
                name: '相关文章',
                children: article,
              },
              {
                name: '历史问卷',
                children: history,
              },
            ]
          }
        )
        .catch((params) => {
          console.log(params, '底部脚本错误')
          throw new Error(params)
        })
    },
    // 接口获取数据
    getData() {
      const taskList = [getRecomment, getSimpleLastest, getSimpleHistory]
      return Promise.all(taskList.map((v) => v())).then(
        ([
          {
            data: { list_data: recomment },
          },
          {
            data: { list_data: lastest },
          },
          {
            data: { list_data: history },
          },
        ]) => {
          this.data = [
            {
              name: '推荐专题',
              children: recomment.concat(recomment).map((v) => ({
                ...v,
                title: v.title_as_txt,
                count: `共${v.lib_count}份模板`,
              })),
            },
            {
              name: '最新模板',
              children: lastest.map((v) => ({
                ...v,
                count: `共${v.question_count}题/${v.page_count}页`,
              })),
            },
            {
              name: '历史项目',
              children: history.map((v) => ({
                ...v,
                title: v.name,
                count: `共${v.lib_count || 0}份模板`,
              })),
            },
          ]
        }
      )
    },
    // 查看更多
    showMore(name) {
      const url = {
        推荐专题: '/topic_list/',
        最新模板: '/share/more_share/',
        历史项目: '/static_history',
        相关专题: '/topic_list/',
        相关文章: '/blog/',
        历史问卷: '/static_history/',
      }[name]
      return url
    },
  },
}
